import { useFeatureFlags } from "./useFeatureFlags"

export const KAMAE_CHATBOT_FLAG = "kamae-chatbot"

export const useKamaeChatbotFlag = () => useFeatureFlags().includes(KAMAE_CHATBOT_FLAG)
